import { useState } from 'react'
import { ClipType, CollaborationStatus } from '../../gql/types'
import {
  Badge,
  BadgeSize,
  BadgeType,
  Button,
  ButtonColor,
  ButtonSize,
  ButtonStyle,
} from '..'
import { RequestEditsModal } from '../../brands/shared/RequestEditsModal'

export const RequestEditsButton = ({ clip, type, className = '' }) => {
  const [isRequestEditsModalOpen, setIsRequestEditsModalOpen] = useState(false)

  if (!clip || !type || type !== 'brand') {
    return null
  }

  return (
    <div className={className}>
      <div className='my-1 flex items-center justify-start text-base font-medium text-gray-900'>
        {!clip?.collaboration?.editsRequestMessage &&
          clip?.collaboration?.status === CollaborationStatus.contentUploaded &&
          clip?.type === ClipType.firstVersion && (
            <Button
              title='Request Edits'
              type='button'
              styleType={ButtonStyle.fill}
              colour={ButtonColor.secondary}
              size={ButtonSize.small}
              onClick={() => {
                setIsRequestEditsModalOpen(true)
              }}
              // className='!border !border-gray-900 shadow-xl rounded-full'
            />
          )}
        {clip?.collaboration?.editsRequestMessage && (
          <Badge
            type={BadgeType.sky}
            text='Edit Requested'
            size={BadgeSize.small}
            className='!mr-0'
          />
        )}
      </div>
      {isRequestEditsModalOpen && (
        <RequestEditsModal
          collaboration={clip.collaboration}
          isOpen={isRequestEditsModalOpen}
          setIsOpen={setIsRequestEditsModalOpen}
        />
      )}
    </div>
  )
}
